import { removeToken } from '../utils/tokenStore';
import api from './api';

const authService = {
  async login(username, password, centreId = null, roleId = null) {
    const payload = { username, password };
    if (centreId) {
      payload.centreId = parseInt(centreId, 10);
    }
    if (roleId) {
      payload.roleId = parseInt(roleId, 10);
    }
    const response = await api.post('/auth/login', payload);
    return response.data;
  },

  async logout(refreshToken = null, loginDetailId = null) {
    try {
      await api.post('/auth/logout', {
        refreshToken: refreshToken || undefined,
        loginDetailId: loginDetailId || undefined,
      });
    } catch (e) {
      // Ignore network errors on logout
    } finally {
      removeToken('lis_access_token');
      removeToken('lis_refresh_token');
      localStorage.removeItem('lis_user');
      localStorage.removeItem('lis_login_detail_id');
    }
  },

  async getMe() {
    const response = await api.get('/auth/me');
    return response.data;
  },

  async getHealth() {
    const response = await api.get('/health');
    return response.data;
  },

  async changePassword(currentPassword, newPassword, confirmNewPassword) {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword,
      confirmNewPassword
    });
    return response.data;
  },

  async adminResetPassword(employeeId, newPassword, forcePasswordChangeOnNextLogin = true) {
    const response = await api.post('/auth/admin-reset-password', {
      employeeId,
      newPassword,
      forcePasswordChangeOnNextLogin
    });
    return response.data;
  },

  async getPasswordExpiryStatus() {
    const response = await api.get('/auth/password-expiry-status');
    return response.data;
  },

  async getMySessions() {
    const response = await api.get('/auth/my-sessions');
    return response.data;
  },

  async logoutOtherDevices() {
    const response = await api.post('/auth/logout-other-devices');
    return response.data;
  },

  async getMyLoginHistory() {
    const response = await api.get('/auth/my-login-history');
    return response.data;
  },

  async getPasskeyCredentials(employeeId) {
    const response = await api.get(`/auth/passkey/credentials/${employeeId}`);
    return response.data;
  },

  async getFaceEnrollmentStatus(employeeId) {
    const response = await api.get(`/auth/face/status/${employeeId}`);
    return response.data;
  },

  async reAuthenticate(currentPassword) {
    const response = await api.post('/auth/re-authenticate', {
      currentPassword
    });
    return response.data;
  },

  async updateMyProfile(profileData, reAuthToken = null) {
    const config = {};
    if (reAuthToken) {
      config.headers = { 'X-Reauth-Token': reAuthToken };
    }
    const response = await api.put('/auth/my-profile', profileData, config);
    return response.data;
  }
};

export default authService;
